import { useQuery } from "@tanstack/react-query";
import { ExternalDBOverview } from "../utils/models";
import { getErrorMessage } from "../utils/utilities";

import dbService from "../services/dbService";

interface ExternalDBState {
    refetch: () => void;
    overview: ExternalDBOverview;
    loading: boolean;
    error: boolean;
    lastUpdated: number | null;
}

const initialExternalDBOverview = {
	acceptedReports: 0,
	recentProjects: [],
	rejectedReports: 0,
	reportByInspectionType: [],
	riskRating: [],
	totalActiveReports: 0,
	totalApprovedReports: 0,
	totalPendingReports: 0,
	totalReports: 0,
};

const useExternalDashboard = (): ExternalDBState => {
    const { data, dataUpdatedAt, error, isFetching, refetch } = useQuery({
        queryKey: ['external-user-details'],
        queryFn: () => dbService.getExternalDashboard(),
        initialData: initialExternalDBOverview,
    });

    return {
        overview: data,
        loading: isFetching,
        error: error ? getErrorMessage(error) : '',
        lastUpdated: dataUpdatedAt,
        refetch,
    };
};
 
export default useExternalDashboard;